import { Box, Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

export type IHttpMethodType = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface IMethodProps {
  isEditable: boolean;
  method: IHttpMethodType;
  style?: any;
  onChange: (path: string[], val: string) => void;
}
export const Method: FC<IMethodProps> = ({ isEditable, method, onChange, style }) => (
  <Box style={style}>
    <Select
      label="Method"
      sx={{ marginY: 1 }}
      onChange={(val: any) => onChange(['method'], val?.value)}
      options={['GET', 'POST', 'PUT', 'DELETE', 'PATCH']?.map(m => ({
        value: m,
        label: m
      }))}
      value={{ label: method?.toUpperCase(), value: method }}
      disabled={!isEditable}
      disableClearable
    />
  </Box>
);
